import { fetchJSON } from '@bonnet/next/fetch';
export default async data => fetchJSON('/cars-for-sale/consumer-id', {
  method: 'POST',
  body: {
    email: data?.email,
    // Valid brands for this api are AT, KBB and FORD
    // Default to AT
    brand: data?.brand || 'AT'
  },
  circuitBreaker: {
    id: 'consumerId',
    timeout: 5000,
    resetTimeout: 300000,
    fallback: {}
  }
});